/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Kind_OtherInputs */



/**
* | output |
* | --- |
* | "Other" |
*
* @param {Promo_Kind_OtherInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_kind_other = /** @type {((inputs?: Promo_Kind_OtherInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Kind_OtherInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Autre")
	if (locale === "es") return /** @type {LocalizedString} */ ("Otro")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Outro")
	if (locale === "it") return /** @type {LocalizedString} */ ("Altro")
	return /** @type {LocalizedString} */ ("Other")
});